import React, { useState } from "react";
import { apiFetch } from "../lib/api";

export default function AdWizard({ onClose, smartLinks }) {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    smart_link_id: smartLinks[0]?.id || "",
    daily_budget: "5",
    interest_id: "",
    interest_name: "",
    creative_url: ""
  });

  // Step 4: Targeting Logic
  const [searchQ, setSearchQ] = useState("");
  const [interests, setInterests] = useState([]);
  
  const searchInterests = async () => {
    if(!searchQ) return;
    setLoading(true);
    try {
      const res = await apiFetch(`/api/fb/interests?q=${searchQ}`);
      setInterests(res.items || []);
    } catch(e) {
      alert("Failed to search Facebook API");
    } finally {
      setLoading(false);
    }
  };

  const launchAd = async () => {
    setLoading(true);
    try {
      await apiFetch("/api/fb/launch", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      alert("Campaign Launched Successfully! 🚀");
      onClose();
    } catch (e) {
      alert("Error launching ad: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="psl-modal-overlay">
      <div className="psl-modal" style={{ width: 500 }}>
        <div className="psl-modal-top">
          <h3>Launch Ad Campaign (Step {step}/4)</h3>
          <button className="psl-btn" onClick={onClose}>✕</button>
        </div>

        {/* STEP 1: SELECT MUSIC */}
        {step === 1 && (
          <div>
            <label className="psl-label">Select Release (Smart Link)</label>
            <select 
              className="psl-input" 
              value={payload.smart_link_id}
              onChange={e => setPayload({...payload, smart_link_id: e.target.value})}
            >
              {smartLinks.map(l => (
                <option key={l.id} value={l.id}>{l.title} - {l.artist}</option>
              ))}
            </select>
            <button className="psl-btn primary" style={{width:'100%', marginTop: 15}} onClick={() => setStep(2)}>Next: Creative</button>
          </div>
        )}

        {/* STEP 2: CREATIVE (Simplified URL input for MVP) */}
        {step === 2 && (
          <div>
            <label className="psl-label">Video/Image URL</label>
            <input 
              className="psl-input" 
              placeholder="https://dropbox.com/..." 
              value={payload.creative_url}
              onChange={e => setPayload({...payload, creative_url: e.target.value})}
            />
            <p className="psl-muted" style={{fontSize:12}}>Paste a direct link to your ad creative (mp4/jpg).</p>
            <div style={{display:'flex', gap: 10, marginTop: 15}}>
              <button className="psl-btn" onClick={() => setStep(1)}>Back</button>
              <button className="psl-btn primary" style={{flex:1}} onClick={() => setStep(3)}>Next: Targeting</button>
            </div>
          </div>
        )}

        {/* STEP 3: TARGETING (The "Hypeddit" Magic) */}
        {step === 3 && (
          <div>
            <label className="psl-label">Search Interests (e.g. "Daft Punk")</label>
            <div style={{display:'flex', gap: 5}}>
              <input 
                className="psl-input" 
                value={searchQ}
                onChange={e => setSearchQ(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && searchInterests()}
              />
              <button className="psl-btn" onClick={searchInterests} disabled={loading}>Search</button>
            </div>

            <div style={{maxHeight: 200, overflowY:'auto', marginTop: 10, border: '1px solid #333', borderRadius: 8}}>
              {interests.map(i => (
                <div 
                  key={i.id} 
                  onClick={() => setPayload({...payload, interest_id: i.id, interest_name: i.name})}
                  style={{
                    padding: 8, 
                    cursor:'pointer', 
                    background: payload.interest_id === i.id ? 'var(--psl-accent)' : 'transparent'
                  }}
                >
                  <div style={{fontWeight:700}}>{i.name}</div>
                  <div style={{fontSize:11, opacity:0.7}}>Size: {i.audience_size_upper_bound?.toLocaleString()}</div>
                </div>
              ))}
            </div>

            <div style={{display:'flex', gap: 10, marginTop: 15}}>
              <button className="psl-btn" onClick={() => setStep(2)}>Back</button>
              <button className="psl-btn primary" style={{flex:1}} disabled={!payload.interest_id} onClick={() => setStep(4)}>Next: Budget</button>
            </div>
          </div>
        )}

        {/* STEP 4: BUDGET & LAUNCH */}
        {step === 4 && (
          <div>
            <label className="psl-label">Daily Budget ($)</label>
            <input 
              type="number"
              className="psl-input" 
              value={payload.daily_budget}
              onChange={e => setPayload({...payload, daily_budget: e.target.value})}
            />
            
            <div className="psl-notice" style={{position:'static', transform:'none', marginTop: 20}}>
              Summary: Spending ${payload.daily_budget}/day targeting "{payload.interest_name}"
            </div>

            <div style={{display:'flex', gap: 10, marginTop: 15}}>
              <button className="psl-btn" onClick={() => setStep(3)}>Back</button>
              <button className="psl-btn primary" style={{flex:1}} onClick={launchAd} disabled={loading}>
                {loading ? "Launching..." : "Launch Campaign 🚀"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}